import * as React from "react";
import {ISubmissionProps} from "../utils/models";
import {useEffect, useState} from "react";
import {getSurveySubmissions} from "../utils/submissions";
import Loader from "../../../shared/Loader";
import FoodOut from "../FoodOut";
import FoodIn from "../FoodIn";

const FoodInFoodOut = ({container, selectedUoa, selectedYear, survey}: ISubmissionProps) => {
    const [loading, setLoading] = useState(true);
    const [submissions, setSubmissions] = useState([]);

    const getSurveysData = async () => {
        setLoading(true)

        if (survey) {
            const data = await getSurveySubmissions({container, survey_id: survey, selectedUoa, selectedYear})
            setSubmissions(data)
        }
    }

    useEffect(() => {
        getSurveysData().then(() => setLoading(false));
    }, [selectedUoa, selectedYear]);

    return (
        <>
            {
                !loading && (
                    <>
                        <FoodIn submissions={submissions} />
                        <FoodOut submissions={submissions} />
                    </>
                )
            }
            {
                loading && (
                    <div className="loader-container col-span-2">
                        <Loader size={60}/>
                    </div>
                )
            }
        </>
    );
}

export default FoodInFoodOut;